module.exports = __webpack_public_path__ + "i18n/pl.722146d1420c69726c69b40bfffd3c4e.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/pl.json
// module id = 1313
// module chunks = 59